import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { Redirect, withRouter } from 'react-router-dom';
import { Loader } from '@bambuser-ui';
import * as ROUTES from 'constants/routes.js';
import { hasDatePassed } from 'utils/index.js';

import { withFirebase } from '../Firebase/index.js';
import NoOrgAccess from 'components/NoOrgAccess/index.jsx';
import { withFeatures } from 'contexts/FeatureContext.jsx';

const withLandingRedirect = Component => {
  class WithLandingRedirect extends React.Component {
    constructor(props) {
      super(props);
      this.state = {};
    }

    componentDidMount() {
      this.listener = this.props.firebase.onAuthUserListener(
        authUser => {
          this.setState({
            memberships: authUser.memberships,
          });
        },
        () => {},
      );
    }

    componentWillUnmount() {
      this.listener();
    }

    render() {
      const { memberships, selectedOrgId } = this.state;
      if (!memberships) return <Loader />;

      const membershipsWithAccess = memberships
        .filter(({ user }) => !user.expirationDate || !hasDatePassed(user.expirationDate));

      if (membershipsWithAccess.length === 1) {
        return <Component {...this.props} orgId={membershipsWithAccess[0].user.orgId} />;
      }
      if (membershipsWithAccess.length < 1) return <NoOrgAccess memberships={memberships} />;
      if (selectedOrgId) return <Component {...this.props} orgId={selectedOrgId} />;

      return <Redirect to={ROUTES.LANDING} />;
    }
  }

  return compose(
    withRouter,
    withFirebase,
    withFeatures,
    connect(state => ({
      authUser: state.sessionState.authUser,
    })),
  )(WithLandingRedirect);
};

export default withLandingRedirect;
